import { Icon } from '@orbita-ui/core';
import { useContext, useEffect, useState } from 'react';
import { SortableTableContext } from 'shared/table/contexts/SortableTableContext';
import styled from 'styled-components';

const TableHeader = styled.th<{ $disabled?: boolean }>`
  div {
    display: flex;
    align-items: center;
    padding-right: 8px;
    cursor: ${(props) => (props.$disabled ? 'auto' : 'pointer')};

    span {
      flex: 1;
    }

    svg {
      height: 16px;
      width: 16px;
      color: rgb(31, 41, 51);
    }
  }

  &:hover {
    background: ${(props) =>
      props.$disabled ? 'rgba(203, 210, 217, 0.3)' : 'rgba(0, 0, 0, 0.1)'};
  }
`;

interface THProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  column: string;
  disabled?: boolean;
}

type SortOrder = 'asc' | 'desc' | 'default';

const getIcon = (sortOrder: SortOrder) => {
  switch (sortOrder) {
    case 'asc':
      return <Icon name="ArrowUpIcon" />;
    case 'desc':
      return <Icon name="ArrowDownIcon" />;
    default:
      return (
        <Icon
          style={{
            transform: 'rotate(90deg)',
          }}
          name="SortHorizontalIcon"
        />
      );
  }
};

export const SortableTableHeader = ({
  column,
  disabled,
  children,
  ...props
}: THProps) => {
  const { filter, setFilter } = useContext(SortableTableContext);
  const [sortOrder, setSortOrder] = useState<SortOrder>('default');

  useEffect(() => {
    if (column !== filter?.columnName) {
      setSortOrder('default');
    }
  }, [filter, column]);

  return (
    <TableHeader
      $disabled={disabled}
      onClick={() => {
        if (disabled) {
          return;
        }
        setSortOrder((order) =>
          order === 'default' || order === 'desc' ? 'asc' : 'desc',
        );
        setFilter({
          columnName: column,
          sortOrder,
        });
      }}
      {...props}
    >
      <div>
        <span>{children}</span>
        {!disabled && getIcon(sortOrder)}
      </div>
    </TableHeader>
  );
};
